module.exports = __webpack_public_path__ + "img/integrated-multipoint-lock.803fbe2.svg";